var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42764 0.998047L8.5705 0.998047V3.85519H7.42764V0.998047Z",
    fill: "#8A91A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 4.9415L13.2533 2.9375L14.0613 3.74607L12.0579 5.7495L11.2499 4.9415Z",
    fill: "#8A91A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1425 8.42578H15.9996V9.56864H13.1425V8.42578Z",
    fill: "#8A91A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 13.056L12.0579 12.248L14.0613 14.2515L13.2533 15.06L11.2499 13.056Z",
    fill: "#8A91A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42764 14.1406H8.5705V16.9978H7.42764V14.1406Z",
    fill: "#8A91A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93936 14.2515L3.94279 12.248L4.75079 13.0566L2.74736 15.06L1.93936 14.2515Z",
    fill: "#8A91A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.15527e-05 8.42578H2.85705V9.56864H-9.15527e-05L-9.15527e-05 8.42578Z",
    fill: "#8A91A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93936 3.74607L2.74736 2.9375L4.75079 4.9415L3.94279 5.7495L1.93936 3.74607Z",
    fill: "#8A91A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51261 6.77173C6.9531 6.47741 7.47097 6.32031 8.00075 6.32031C8.71115 6.32031 9.39245 6.60252 9.89478 7.10485C10.3971 7.60718 10.6793 8.28848 10.6793 8.99888C10.6793 9.52865 10.5222 10.0465 10.2279 10.487C9.93357 10.9275 9.51524 11.2708 9.02579 11.4736C8.53635 11.6763 7.99777 11.7293 7.47818 11.626C6.95859 11.5226 6.48132 11.2675 6.10671 10.8929C5.73211 10.5183 5.477 10.041 5.37364 9.52145C5.27029 9.00185 5.32333 8.46328 5.52607 7.97384C5.7288 7.48439 6.07212 7.06606 6.51261 6.77173Z",
    stroke: "#8A91A8",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/Light.5340abc421cf1406ec1f4fc78b6ff9bf.svg";
export { ForwardRef as ReactComponent };